import * as React from 'react'
import styled from 'styled-components'
import * as Redux from 'react-redux'

import type * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as models from '@owl-nest/models'
import { InputWrapper, Tip, TipContainerWrapper } from '@owl-nest/tip'
import * as plume from '@ulule/owl-kit-components/next'
import * as shadow from '@owl-nest/shadow'

import * as modalAction from '../../../../actions/modal'
import * as URLs from '../../../utils/URLs'

type DonationBlockProps = {
  context?: string
  project: api.Project
  withFromMention?: boolean
}

export function DonationBlock({
  context,
  project,
  withFromMention = false,
}: DonationBlockProps): React.ReactElement<any> {
  const isDonationBasedProject = models.project.isDonationBased(project)
  const allowedFrequency = models.project.allowedDonationFrequency(project)

  const dispatch = Redux.useDispatch()
  const tracking = shadow.useTracking()

  return (
    <TipWrapper className="tip-view-tip-component">
      <plume.styles.heading.XS
        className={isDonationBasedProject && allowedFrequency === 'all' ? 'tip-title-tip-component' : undefined}
      >
        {t('Donate')}
      </plume.styles.heading.XS>
      <StyledTip
        allowNullValue
        context={context}
        disableCta={!models.project.isOnline(project)}
        handleFormSubmit={(values) => {
          if (!models.project.isOrdersEnabled(project)) {
            dispatch(modalAction.toggleModalPaymentDisturbance(true))
          } else {
            tracking.ecommerce.track('add_to_cart', {
              currency: project.currency,
              value: values.donation,
              items: [
                {
                  item_id: 'tip',
                  item_name: 'tip',
                  item_brand: models.project.name(project),
                  price: values.donation,
                  quantity: 1,
                },
              ],
            })

            window.location.href = URLs.getCheckoutURL(project.id, {
              donationFrequency: values.frequency,
              tipAmount: values.donation,
            })
          }
        }}
        project={project}
        translations={{
          placeholder: isDonationBasedProject ? '' : t('5, 10, 25, 50, whatever you want!'),
          submit: t('Donate'),
        }}
        withPresets={isDonationBasedProject}
        withFromMention={withFromMention}
      />
    </TipWrapper>
  )
}

const StyledTip = styled(Tip)`
  justify-content: flex-start;
  padding: 0 0 20px 0;

  ${InputWrapper} {
    margin-right: 0;
  }

  ${plume.Button} {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
  }

  ${TipContainerWrapper} {
    flex-wrap: wrap;
    margin-top: 20px;
  }
`

const TipWrapper = styled.div`
  border: 1px solid ${plume.COLORS.GREY_SHADE_5};
  padding-top: 15px;
  /* We want those elements to be 90% of container width. This means padding
  of 5% of container width so those paddings are (5/90)*100 % of element
  width */
  padding-left: ${(5 / 90) * 100}%;
  padding-right: ${(5 / 90) * 100}%;
  margin-top: -1px;

  ${plume.styles.heading.S} {
    margin-bottom: 5px;
  }

  ${plume.styles.copy.M.light} {
    color: ${plume.COLORS.GREY_SHADE_2};
    margin-bottom: 13px;
  }
`
